//
//
//
//
//
//

export default {
    name: "textcomponent",
    props: ["content"]
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/player/page/textcomponent.vue
// module id = 57
// module chunks = 0